// Module
var code = `<div class="selectable-list__header">
  <span class="label">Select all on page</span>
  <input type="checkbox"
         ng-checked="\$ctrl.isEveryRecordChecked()"
         ng-click="\$ctrl.toggleAllRecords(\$event)"/>
  <span>Selected {{ \$ctrl.checkedRecords.length }} of {{ \$ctrl.total ? \$ctrl.total : '-' }}</span>
</div>

<table ng-table="\$ctrl.tableConfig" class="table">
  <tr>
    <th>No.</th>
    <th ng-repeat="column in \$ctrl.columns">{{ column.label }}</th>
    <th>{{ \$ctrl.selectableColumnLabel }}</th>
  </tr>
  <tr ng-repeat="record in \$data" ng-if="\$data" ng-class="{'checked': \$ctrl.isRecordChecked(record)}">
    <td>{{ \$ctrl.currentPage * \$ctrl.recordsPerPage + \$index + 1 }}</td>
    <td ng-repeat="col in \$ctrl.columns" ng-class="col.align">{{ record[col.field] }}</td>
    <td>
      <input type="checkbox"
        ng-click="\$ctrl.toggleSingleRecord(\$event, record)"
        ng-checked="\$ctrl.isRecordChecked(record)"
        ng-disabled="\$ctrl.isRecordDisabled(record)"/>
    </td>
  </tr>
  <tr ng-if="!\$data.length" class="table__empty-message table__row--not-hoverable"><td colspan="9">There are no items to show</td></tr>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/selectable-list/selectable-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;